"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertyValidator = exports.usePropertyValidation = exports.useBedsValidation = exports.getBedsErrorMsg = exports.useBathroomValidation = exports.getBathroomErrorMsg = void 0;
const React = __importStar(require("react"));
const ValidationContext_1 = require("../../context/ValidationContext");
const validators_1 = require("./validators");
;
const getBathroomErrorMsg = (bathrooms) => {
    // if no bathrooms
    if (!bathrooms || bathrooms.length === 0) {
        return { valid: false, errorMsg: 'We require at least one toilet, sink and bath or shower per property.' };
    }
    // if bathrooms but nothing selected
    else if (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.every((b) => b.toilet_type === 'none' && b.bath_type === 'none' && b.shower_type === 'none')) {
        return { valid: false, errorMsg: 'We require at least one toilet, sink and bath or shower per property.' };
    }
    // all bathrooms do not have a sink/toilet
    else if (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.every((b) => b.toilet_type === 'none')) {
        return { valid: false, errorMsg: 'We require at least one toilet and sink per property.' };
    }
    // if bathrooms but only have toilet/sink
    else if (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.every((b) => b.bath_type === 'none' && b.shower_type === 'none')) {
        return { valid: false, errorMsg: 'We require at least one bath or shower per property.' };
    }
    // if some bathroom has nothing selected
    else if (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.some((b) => b.toilet_type === 'none' && b.bath_type === 'none' && b.shower_type === 'none')) {
        return { valid: false, errorMsg: 'Bathrooms cannot be empty.' };
    }
    else {
        return { valid: true };
    }
};
exports.getBathroomErrorMsg = getBathroomErrorMsg;
const useBathroomValidation = (selector, bathrooms) => {
    const validationContext = React.useContext(ValidationContext_1.ValidationContext);
    const [valid, setValid] = React.useState({ valid: true });
    React.useEffect(() => {
        const bathroomState = (0, exports.getBathroomErrorMsg)(bathrooms);
        if (validationContext.state.property.fields.bathrooms !== bathroomState.valid) {
            validationContext.dispatch(ValidationContext_1.validationActions.updateProperty(selector, bathroomState.valid));
        }
        setValid(bathroomState);
    }, [bathrooms]);
    return [valid.valid, valid.errorMsg];
};
exports.useBathroomValidation = useBathroomValidation;
const getBedsErrorMsg = (property) => {
    var _a;
    // if no beds defined or too many
    if (((_a = property.beds) === null || _a === void 0 ? void 0 : _a.length) === 0 || property.capacity >= 50) {
        return { valid: false, errorMsg: 'Must add at least one bed and have no more than a capacity of 50.' };
    }
    // if studio with some bedrooms
    else if (property.property_type === 'studio' && property.beds.some(bed => bed.bedroom !== null)) {
        return { valid: false, errorMsg: 'You cannot have bedrooms in your studio.' };
    }
    // if not a studio and no bedrooms
    else if (property.property_type !== 'studio' && property.beds.every(bed => bed.bedroom === null)) {
        return { valid: false, errorMsg: `You must have at least one bedroom in your ${property.property_type}.` };
    }
    return { valid: true };
};
exports.getBedsErrorMsg = getBedsErrorMsg;
const useBedsValidation = (selector, property) => {
    const validationContext = React.useContext(ValidationContext_1.ValidationContext);
    const [valid, setValid] = React.useState({ valid: true });
    React.useEffect(() => {
        const bedState = (0, exports.getBedsErrorMsg)(property);
        if (validationContext.state.property.fields.beds !== bedState.valid) {
            validationContext.dispatch(ValidationContext_1.validationActions.updateProperty(selector, bedState.valid));
        }
        setValid(bedState);
    }, [property]);
    return [valid.valid, valid.errorMsg];
};
exports.useBedsValidation = useBedsValidation;
const propertyValidator = (s, rules) => {
    return { [s]: rules };
};
const usePropertyValidation = (selector, property) => {
    const validators = propertyValidators[selector];
    if (!validators || !validators.length) {
        throw new Error(`No validator for ${selector.toString()}`);
    }
    const validationContext = React.useContext(ValidationContext_1.ValidationContext);
    const [errMsg, setErrMsg] = React.useState('');
    React.useEffect(() => {
        let currentErrMsg = '';
        if (property) {
            validators.forEach((validator) => {
                if (!currentErrMsg && !validator.fn(property[selector])) {
                    currentErrMsg = validator.errMsg;
                }
            });
            const isValid = !currentErrMsg;
            if (validationContext.state.property.fields[selector] !== isValid) {
                validationContext.dispatch(ValidationContext_1.validationActions.updateProperty(selector, isValid));
            }
        }
        setErrMsg(currentErrMsg);
    }, [property]);
    return [!errMsg, (!errMsg ? undefined : errMsg)];
};
exports.usePropertyValidation = usePropertyValidation;
const getPropertyValidator = (selector) => {
    return propertyValidators[selector];
};
exports.getPropertyValidator = getPropertyValidator;
// Note that these rules are duplicated in client_api:
// https://github.com/TravelNest/client_api/blob/master/src/property/validation.ts
// So if you make changes here, they should be equivalently changed there
// The "supportedCharsOnly" checks are intentionally not replicated there to limit any issues with publishing existing properties
const propertyValidators = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, propertyValidator('internal_name', [{
        fn: (internalName) => !!internalName && internalName.trim().length > 0 && internalName.trim().length <= 30,
        errMsg: 'Must provide a valid property nickname.'
    }])), propertyValidator('country_code', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must select a country code.'
    }])), propertyValidator('name', [{
        fn: (name) => !!name && name.trim().length >= 20 && name.trim().length <= 50,
        errMsg: 'Property title must be at least 20 characters long, but no more than 50.'
    },
    {
        fn: validators_1.supportedCharsOnly,
        errMsg: 'Property title contains invalid characters.'
    },
    {
        fn: validators_1.supportedWordsOnly,
        errMsg: 'Property title cannot include the words "safe", "clean" and "sterile".'
    },
    {
        fn: validators_1.max5ConsecutiveDigits,
        errMsg: 'Property title cannot include more than 5 consecutive digits.'
    }])), propertyValidator('address1', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide a valid property address.'
    },
    {
        fn: validators_1.supportedCharsOnly,
        errMsg: 'Property address contains invalid characters.'
    }])), propertyValidator('address2', [{
        fn: validators_1.supportedCharsOnly,
        errMsg: 'Property address contains invalid characters.'
    }])), propertyValidator('amenities', [{
        fn: (amenities) => amenities.length >= 5,
        errMsg: 'Must select at least 5 amenities.'
    }])), propertyValidator('bathrooms', [{
        fn: (bathrooms) => bathrooms.length >= 1,
        errMsg: 'Must add at least one bathroom.'
    }])), propertyValidator('check_in', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide a check-in time.'
    }])), propertyValidator('check_out', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide a check-out time.'
    }])), propertyValidator('city', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide the city/town/village your property is located in (or near).'
    },
    {
        fn: validators_1.supportedCharsOnly,
        errMsg: 'City contains invalid characters.'
    }])), propertyValidator('latitude', [{
        fn: (lat) => lat !== undefined && !isNaN(lat),
        errMsg: 'Must provide your property\'s latitude.'
    }])), propertyValidator('longitude', [{
        fn: (lon) => lon !== undefined && !isNaN(lon),
        errMsg: 'Must provide your property\'s longitude.'
    }])), propertyValidator('long_description', [{
        fn: (description) => !!description && description.length >= 400,
        errMsg: 'Your description must have a minimum of 400 characters.'
    }])), propertyValidator('postcode', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide your property\'s postcode.'
    }])), propertyValidator('property_size', [{
        fn: (size) => !!size && size > 0,
        errMsg: 'Must provide the size of your property.'
    }])), propertyValidator('property_type', [{
        fn: validators_1.stringPresent,
        errMsg: 'Must provide a property type.'
    }])), propertyValidator('security_deposit', [{
        fn: (deposit) => deposit === 0 || (deposit >= 100 && deposit <= 1725),
        errMsg: 'Deposit must be £0 or between £100 to £1725'
    }]));
//# sourceMappingURL=property.js.map